<!-- <section class="onBoard">
  <div class="container">
    <div class="scrollWrap"> -->
<div class="boradLogo text-center">
  <img src="assets/images/logo/confe-light-web.svg" alt="" />
</div>
<div *ngIf="timezoneList.length" class="boardWrap">
  <div class="quesitionBlock">
    <div class="titleBlock">
      <h2 class="text-center">Set your timezone</h2>
    </div>
    <div class="row align-items-center">
      <div class="col-md-7">
        <div *ngIf="isUserTimezoneValid()" class="zoneTxt">
          <h3 class="text-center">Your timezone appears to be:</h3>
          <span class="current-timezone text-center">{{ getUserCurrentTimeZone() }}</span>
        </div>

        <div class="inputRow">
          @if (timezoneList.length) {
            <p-dropdown
              [(ngModel)]="selectedTimezone"
              [options]="timezoneList"
              placeholder="Select your Timezone"
              [group]="true"
            >
              <ng-template let-group pTemplate="group">
                <div class="flex align-items-center">
                  <span>{{ group.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          } @else {}
        </div>
        <p-messages *ngIf="showError" [(value)]="msgs" [enableService]="false" />

        <p-button
          [disabled]="!selectedTimezone || isLoading"
          styleClass="blueBtn"
          label="Get Started"
          (click)="updateUserTimeZone()"
        >
          <ng-template pTemplate="icon">
            <i *ngIf="isLoading" class="pi pi-spin pi-spinner"></i>
          </ng-template>
        </p-button>
      </div>
      <div class="col-md-5">
        <div class="zoneMsg">
          <div class="infoIcon">
            <img src="/assets/images/html/round-information-blue-icon.svg" alt="" />
          </div>
          <p>
            Select a timezone that matches your local time. This will ensure the correct time is
            displayed whenever you schedule a post.
          </p>
          <p>Choosing the wrong timezone may result in inaccurate posting times.</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div>
  </div>
</section> -->
